import React from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
} from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';
import { BottomNavigation } from '../layout/BottomNavigation';
import { useNavigate } from 'react-router-dom';

const settingsOptions = [
  { text: 'VER OPÇÕES DE PLANOS', route: '/pricing', external: false },
  { text: 'POLÍTICA DE PRIVACIDADE', route: '/privacy-policy', external: false },
  { text: 'CONTATO', route: '/contact', external: false },
  { text: 'SOBRE O APP', route: null, external: false },
];

export const GeneralSettingsPage: React.FC = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleOptionClick = (option: typeof settingsOptions[0]) => {
    if (!option.route) return;

    if (option.external) {
      window.open(option.route, '_blank');
    } else {
      navigate(option.route);
    }
  };

  return (
    <>
      <Box sx={{
        backgroundColor: theme.colors.background,
        minHeight: '100vh',
        paddingBottom: '120px',
      }}>
        <Box sx={{ paddingTop: '70px' }}>
          <List sx={{ padding: 0 }}>
            {settingsOptions.map((option, index) => (
              <React.Fragment key={option.text}>
                <ListItemButton
                  sx={{ padding: '16px 24px' }}
                  onClick={() => handleOptionClick(option)}
                  disabled={!option.route}
                >
                  <ListItemText
                    primary={
                      <Typography sx={{
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        color: !option.route ? theme.colors.text.secondary : theme.colors.text.primary,
                      }}>
                        {option.text}
                      </Typography>
                    }
                  />
                </ListItemButton>
                {index < settingsOptions.length - 1 && (
                  <Divider sx={{
                    marginLeft: '24px',
                    marginRight: '24px',
                    borderColor: theme.colors.border,
                  }} />
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Box>
      <BottomNavigation />
    </>
  );
};
